function c(e) {
  return e.content.cloneNode(!0);
}
function u(e, r) {
  var o, l;
  var t = e.querySelector("[slot=\"".concat(r, "\"]"));
  if (!t) return null;
  var n = t.cloneNode(!0);
  return t.remove(), (l = (o = n.firstChild) == null ? void 0 : o.parentElement) == null || l.removeAttribute("slot"), n;
}
export { u as cloneNamedSlotContent, c as cloneTemplateContent };